import { ANCHOR_POINTS } from '../constants';
import { getCircularDistance } from './getCircularDistance';

// Helper function to find previous and next anchor points
export const findAdjacentAnchors = (currentImage, anchors = ANCHOR_POINTS) => {
  const distances = anchors.map((anchor) => ({
    anchor,
    distance: getCircularDistance(currentImage, anchor),
  }));

  // Sort by distance
  distances.sort((a, b) => a.distance - b.distance);

  return {
    nearest: distances[0].anchor,
    secondNearest: distances[1]?.anchor,
    allDistances: distances,
  };
};
